import React from 'react';
import { Field } from 'react-final-form';

import { required } from '../../sharetribe/utils/validators';
import { ValidationError } from '../../sharetribe/components';

import ListingSelector from './ListingSelector';

const FieldListingSelect = (props) => {
  const {
    className,
    listingSelectorClassName,
    name,
    isRequired,
    requiredText,
    ...rest
  } = props;

  const validate = isRequired ? required(requiredText) : {};

  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <div className={className}>
          <ListingSelector
            className={listingSelectorClassName}
            listingId={input.value}
            onSelect={input.onChange}
            {...rest}
          />
          <ValidationError fieldMeta={meta} />
        </div>
      )}
    </Field>
  );
};

export default FieldListingSelect;
